import { INVITATION_SOCIALS } from "../store/services/invitations/dto/invitations.dto";

export const validateHandle = (value: string, social_type: number): boolean => {
	let socialRegex = "";

	switch (social_type) {
		case INVITATION_SOCIALS.INSTAGRAM: {
			socialRegex = "instagram\\.com\\/([a-zA-Z0-9._]{3,30})";
			break;
		}
		case INVITATION_SOCIALS.FACEBOOK: {
			socialRegex = "(?:m\\.)?facebook\\.com\\/.+";
			break;
		}
		default: {
			socialRegex = "tiktok\\.com\\/\\@([a-zA-Z0-9._]{3,30})";
		}
	}
	const pattern = new RegExp(
		"^https?:\\/\\/(www\\.)?(" + socialRegex + ")\\/?(\\?.*)?$" // optional trailing slash, optional query params
	);

	return pattern.test(value.trim());
};
